<template>
    <div class="form__wrapper">
        <div class="regirect">
            <div class="text">Have an Account?</div>
            <router-link :to="{ name: 'login' }">
                Login
            </router-link>
        </div>
        <div class="form__content">
            <form action="">
                <div class="title">Create Account</div>
                <InputWrapper>
                    <template #text>
                        full name
                    </template>
                    <template #input>
                        <Input v-model:value="v$.valueField.name.$model" :class="{ 'error': v$.valueField.name.$invalid && submitted }"></Input>
                    </template>
                </InputWrapper>
                <InputWrapper>
                    <template #text>
                        email
                    </template>
                    <template #input>
                        <Input v-model:value="v$.valueField.email.$model" :class="{ 'error': v$.valueField.email.$invalid && submitted }"></Input>
                    </template>
                </InputWrapper>
                <InputWrapper>
                    <template #text>
                        Mobile Phone number
                    </template>
                    <template #input>
                        <VueCountryIntl v-model="v$.valueField.mobilePhone.$model" :class="{ 'error': v$.valueField.mobilePhone.$invalid && submitted }"></VueCountryIntl>
                    </template>
                </InputWrapper>
                <InputWrapper>
                    <template #text>
                        Create password
                    </template>
                    <template #input>
                        <InputPasswordValodation v-model:password="v$.valueField.password.$model"></InputPasswordValodation>
                    </template>
                </InputWrapper>
                <InputWrapper>
                    <template #text>
                        Confirm Password
                    </template>
                    <template #input>
                        <InputPassword v-model:password="v$.valueField.confirmPassword.$model" :class="{ 'error': v$.valueField.confirmPassword.$invalid && submitted }"></InputPassword>
                    </template>
                </InputWrapper>
                <!-- <reCAPTCHA></reCAPTCHA> -->
                <RememberMeButton></RememberMeButton>
                <SubmitButton @click="SubmitAuth">Create Account</SubmitButton>
                <SocialAuth></SocialAuth>
            </form>
        </div>
    </div>
    <StatusRequest ref="toast"></StatusRequest>
</template>

<script>
import axios from "axios";
import InputWrapper from '../InputWrapper.vue';
import Input from '../Input.vue';
import RememberMeButton from '../RememberMeButton.vue';
import SubmitButton from '../SubmitButton.vue';
import SocialAuth from '../SocialAuth.vue';
import InputPasswordValodation from '../InputPasswordValodation.vue';
import InputPassword from '../InputPassword.vue';
import { useVuelidate } from '@vuelidate/core'
import { required, email, minLength} from '@vuelidate/validators';
import VueCountryIntl from '@/components/UI/VueCountryIntl.vue';
import StatusRequest from "@/components/UI/StatusRequest.vue";
import messages from '@/assets/json/messages.json';
// import reCAPTCHA from '../reCAPTCHA.vue';
    export default {
        setup: () => ({ v$: useVuelidate() }),
        components: {
            InputWrapper,
            Input,
            RememberMeButton,
            SubmitButton,
            SocialAuth,
            InputPasswordValodation,
            InputPassword,
            VueCountryIntl,
            StatusRequest,
            // reCAPTCHA
        },
        data() {
            return {
                valueField: {
                    name: '',
                    mobilePhone: '',
                    email: '',
                    password: '',
                    confirmPassword: '',
                },
                submitted: false,
            }
        },
        validations() {
            return {
                valueField: {
                    name: { required },
                    mobilePhone: { required },
                    email: { required, email },
                    password: { required, minLength: minLength(8) },
                    confirmPassword: { required, sameAsPassword: this.sameAsPassword },
                }
            }
        },
        methods: {
            sameAsPassword() {
                return this.valueField.confirmPassword === this.valueField.password;
            },
            async SubmitAuth(e) {
                this.submitted = true;
                e.preventDefault();
                if(this.request){
                    return false;
                }
                this.request = true;
                this.v$.$touch();
                if (this.v$.valueField.$invalid) {
                    this.request = false;
                } else {
                    let current_arr = JSON.parse(JSON.stringify(this.valueField));
                    let fData = new FormData();
                    fData.append("name", current_arr.name);
                    fData.append("phone", current_arr.mobilePhone);
                    fData.append("email", current_arr.email);
                    fData.append("password", current_arr.password);

                    try {
                        const response = await axios.post("/registration/account", fData);
                            this.showMessage(true, "Successful registration");
                            setTimeout(() => {
                                this.$router.push({name: "login"});
                            }, 700);
                    } catch(error) {
                        if (error.response) {
                            switch (error.response.status) {
                                case 409:
                                    this.showMessage(false, this.getErrorMessage('email_exists'));
                                    break;
                                case 422:
                                    this.showMessage(false, this.getErrorMessage('invalid_credentials'));
                                    break;
                                case 500:
                                    this.showMessage(false, this.getErrorMessage('unknown_error'));
                                    break;
                                default:
                                    this.showMessage(false, this.getErrorMessage('unknown_error'));
                            }
                        } else {
                            console.error("Network error");
                        }
                    }
                    finally{
                        this.request = false;
                    }
                }
            },
            getErrorMessage(key) {
                return this.messages.errors.registration[key];
                },
            showMessage(type, title) {
                if(type) type='success';
                else type="error";
                const toast = this.$refs.toast;
                toast.show(type,title,5000);
            }
        },
    }
</script>
<style scoped>
.forgot__password{
    color: rgb(5, 5, 5);
    font-size: 13px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
}
.form__wrapper{
    padding: 24px 0;
    height: 100%;
}
.regirect{
    display: flex;
    justify-content: right;
    gap: 16px;
    align-items: center;
}
.regirect .text{
    color: rgb(5, 5, 5);
    font-size: 13px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
    text-align: left;
    }
.regirect a{
    background: rgb(222, 230, 234);
    border-radius: 32px;
    padding: 10px 24px;

    color: rgb(5, 5, 5);
    font-size: 13px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
    text-align: center;
}
.form__content{
    height: calc(100% - 14px);
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}
form{
    width: 322px;
    display: flex;
    flex-direction: column;
    gap: 16px;
}
.title{
    color: rgb(5, 5, 5);
    font-size: 24px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
    padding-bottom: 1px;
}
@media (max-width: 1024px) {
    .form__content{
        height: calc(100% - 14px);
    }
    form{
        height: 100%;
        justify-content: center;
    }
}
</style>